var React = require('react');

function SocialYoutube (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M0 0h16v16H0z","key":0}),React.createElement("path",{"fill":"#FEFEFE","d":"M10.568 7.832L6.59 5.749v4.133l3.978-2.05M8.22 13.189c-1.89-.053-3.199-.078-4.506-.133-.472-.019-.954-.063-1.41-.18-.89-.229-1.25-.934-1.384-1.765a13.763 13.763 0 0 1-.165-1.745C.708 7.853.69 6.34.916 4.835c.064-.422.2-.825.466-1.167.41-.526.986-.7 1.621-.736a94.734 94.734 0 0 1 9.408-.04c.5.02 1.008.062 1.496.17.52.116.9.457 1.129.957.239.522.309 1.077.358 1.639.12 1.365.116 2.732.038 4.098-.038.654-.067 1.313-.297 1.942-.29.794-.857 1.236-1.687 1.277-1.935.096-3.87.16-5.227.214","key":1})]));
}

SocialYoutube.displayName = "SocialYoutube";

SocialYoutube.defaultProps = {"width":"16","height":"16"};

module.exports = SocialYoutube;

SocialYoutube.default = SocialYoutube;



// WEBPACK FOOTER //
// ./src/images/icons/social-youtube.svg